import type { HeadlineV1Attributes } from '@/features/headline-v1/headline-v1-type';

import React from 'react';

import { Headline, ShimmerBox } from '@/core/features';
import color from '@/core/features/styles/color';
import { useHeadlineVariants } from '@/features/headline-v1/use-headline-variants';

export default function HeadlineV1EnumeratedDesktop({
    enumerationNumber,
    htmlSubtitle,
    htmlTitle,
    isLoading,
    subtitleStyle,
    subtitleType,
    titleStyle,
    titleType,
}: HeadlineV1Attributes & { isLoading: boolean }) {
    const { subtitleVariant, titleVariant } = useHeadlineVariants(titleStyle, subtitleStyle, htmlSubtitle);

    if (!titleVariant && !subtitleVariant) {
        return null;
    }

    return (
        <div
            className={`flex items-center ${titleVariant.center ? 'justify-center' : 'flex justify-start items-start'}`}
        >
            <div
                className={'flex justify-center items-center mr-5 font-bold'}
                // eslint-disable-next-line no-inline-styles/no-inline-styles
                style={{ color: color('nobel'), fontSize: '58px' }}
            >
                {enumerationNumber}
            </div>
            <div>
                {titleVariant && (
                    <Headline
                        htmlTitle={htmlTitle}
                        type={titleType}
                        {...titleVariant}
                    />
                )}
                {htmlSubtitle &&
                    subtitleType &&
                    subtitleVariant &&
                    (isLoading ? (
                        <ShimmerBox
                            height={'22px'}
                            width={'50%'}
                        />
                    ) : (
                        <Headline
                            htmlTitle={htmlSubtitle}
                            type={subtitleType}
                            {...subtitleVariant}
                        />
                    ))}
            </div>
        </div>
    );
}
